import React, { useContext, useEffect, useState } from "react";
import "./messageCenter.scss";
import MessageThreadsList from "./MessageThreadsList";
import { messageCenterConfig } from "../../config/MessageCenterConfig";
import MessageForm from "./MessageForm";
import { IReloadMessageComponentModel, MessageThreadModel } from "../../models/MessageCenterModels";
import { BankUserContext } from "../../bankUserContext";

const MessageCenterFC = () => {
  const [conversation, setConversation] = useState<MessageThreadModel | undefined>();
  const { bankuserDetails } = useContext(BankUserContext);
  const [reload, setReload] = useState<IReloadMessageComponentModel>({
    list: false,
    form: false
  });

  return (
    <div className="messageCenterContent mc-container">
      <MessageThreadsList 
        config={messageCenterConfig} 
        conversation={conversation}
        setConversation={setConversation}
        reload={reload}
        setReload={setReload}
      />
      
      <div className="messageFormContainer container-fluid">
        <MessageForm
          config={messageCenterConfig}
          conversation={conversation}
          setConversation={setConversation}
          bankuserDetails={bankuserDetails}
          reload={reload}
          setReload={setReload}
        />
      </div>
    </div>
  );
};

export default MessageCenterFC;
